import React, { FC } from 'react';
import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';
import { TimelineItemsList } from '@v2/pages/machines/modules/timeline/components/TimelineItemsList/TimelineItemsList';
import { NavigationProps } from '@interfaces/navigation';

import { MACHINES_PAGES_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';
import ColorWrapper from '@styles/colors';
import { View } from 'react-native';
import { connect } from 'react-redux';
import { ImagesDocumentsContent } from '@v2/pages/nc-file/details/modules/nc-file/components/ImagesDocumentsContent';
import { DOCUMENT_ENTITY_TYPE } from '@components/imageHandling/common';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { ProductionBatchStatistics } from '@interfaces/search';
import { useBackgroundColor } from '@v2/pages/machines/hooks/useBackgroundColor';

interface BatchDocumentsProps extends NavigationProps {
  batch: ReducerEntityWithLoadingState<ProductionBatchStatistics | null>;
}

const BatchDocumentsComponent: FC<BatchDocumentsProps> = ({ lg, batch }) => {
  const batchId = batch?.data?.productionBatchId;

  const { machineScreenMainBg } = useBackgroundColor();


  return (
    <MachinesProvider lg={lg} panelViewMode={false} onBack={() => {}} getList={(props) => <TimelineItemsList {...props} />} withDefaultComponent>
      {batchId != null && (
        <View style={[MACHINES_PAGES_CONTAINER_STYLES, {paddingHorizontal: 0}]}>
          <ImagesDocumentsContent
            documentRetrieveId={batchId}
            documentRetrieveKey={DOCUMENT_ENTITY_TYPE.Batch}
            bigSliderBg={machineScreenMainBg}
            smallSliderBg={machineScreenMainBg}
          />
        </View>
      )}
    </MachinesProvider>
  );
};

const BatchDocuments = connect(({ batch: { batch } }) => ({ batch }), {})(ColorWrapper(BatchDocumentsComponent));

export { BatchDocuments };
